import React, { FC, ReactNode, useState } from 'react';
import { IKitchenRequest, KitchenInventoryStockContext, KitchenRequestActionType } from './context';
import { StockType } from 'models/stock.model';

export const DefaultKitchenRequest: IKitchenRequest = {
  name: '',
  id: '',
  quantity: '',
  measurement: ''
};

const KitchenInventoryStockProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const selectedRequests: IKitchenRequest[] = [];
  const [requests, setRequests] = useState<IKitchenRequest[]>(selectedRequests);
  const [isPreview, setIsPreview] = useState(false);
  const [scrollIndex, setScrollIndex] = useState<number | null>(null);
  const [stocksToEdit, setStocksToEdit] = useState<StockType[]>([]);
  const [stockToRecordWastage, setStockToRecordWastage] = useState<StockType | null>(null);
  const [actionType, setActionType] = useState<KitchenRequestActionType | null>(null);
  const vendorsArray = [
    {
      name: 'Femite food ltd',
      price: 'N 1,700/gram',
      id: '1'
    },
    {
      name: 'Femite food',
      price: 'N 1,500/gram',
      id: '2'
    },
    {
      name: 'Femite',
      price: 'N 1,200/gram',
      id: '3'
    }
  ];
  return (
    <KitchenInventoryStockContext.Provider
      value={{
        requests,
        setRequests,
        isPreview,
        setIsPreview,
        selectedRequests,
        vendorsArray,
        scrollIndex,
        setScrollIndex,
        stocksToEdit,
        setStocksToEdit,
        stockToRecordWastage,
        setStockToRecordWastage,
        actionType,
        setActionType
      }}>
      {children}
    </KitchenInventoryStockContext.Provider>
  );
};

export default KitchenInventoryStockProvider;
